<template>
	<view class="bargain-container">
		<!--内容-->
		<view class="bargain-list" v-if="!loading">
			<scroll-view scroll-y="true" class="scroll-Y" :style="'height:' + scrollviewHigh + 'px;'" lower-threshold="50">
				
				<!--列表-->
				<view class="list d-s-c f-w">
					<view class="item d-s-s d-stretch" v-for="(item, index) in listData" :key="index">
						<view class="product-cover pr">
							<image :src="item.image.file_path" mode="aspectFit"></image>
						</view>
						<view class="product-info d-b-c d-c">
							<view class="product-title text-ellipsis-2 f26 gray3">{{ item.activity_title }}</view>
							<view class="people-num price">
								<text class="ml10  gray9 f26">{{ item.activity_time_text }}</text>
							</view>
							<view class="people-num price">
								<view>报名截止时间：{{ item.status_text.reg_end_time }}</view>
							</view>
							<view class="d-b-c ww100">
								<view><text  class="ml10  gray9 f26">{{ item.status_text.status_text }}</text></view>
								<view class="right-btn"><button v-if="item.status_text.reg_status == 1" type="primary" @click="gotoDetail(item)">去报名</button></view>
							</view>
						</view>
					</view>
				</view>
				
				<!-- 没有记录 -->
				<view class="none-data-box" v-if="listData.length==0 && !loading">
					<image src="/static/none.png" mode="widthFix"></image>
					<text>暂无数据</text>
				</view>
				
			</scroll-view>
		</view>
	</view>
</template>

<script>
	export default {
		components: {
		},
		data() {
			return {
				/*手机高度*/
				phoneHeight: 0,
				/*可滚动视图区域高度*/
				scrollviewHigh: 0,
				/*商品列表*/
				listData: [],
				status: 0,
				/*是否正在加载*/
				loading: true
			};
		},
		computed: {},
		onLoad(e) {},
		onShow() {
			/*获取列表*/
			this.getlist();
		},
		mounted() {
			this.init();

		},
		onReachBottom() {},
		methods: {
			/*初始化*/
			init() {
				let _this = this;
				uni.getSystemInfo({
					success(res) {
						_this.scrollviewHigh  = res.windowHeight;
					}
				});
			},

			/*获取活动列表*/
			getlist() {
				let self = this;
				uni.showLoading({
					title: '加载中'
				});
				let status = self.status;
				self.loading = true;
				self._get(
					'plus.regactivity.index/index', {
						status: status
					},
					function(res) {
						self.listData = res.data.list.data;
						uni.hideLoading();
						self.loading = false;
					}
				);
			},

			/*跳转详情*/
			gotoDetail(e) {
				let url = 'pages2/regactivity/detail/detail?activity_id=' + e.activity_id
				this.gotoPage(url);
			},

			/*跳转搜索页面*/
			gotoSearch() {
				this.page = 1;
				this.getData();
			},
		}
	};
</script>

<style lang="scss">
	page {
		background: #f2f2f2;
	}

	.bargain-container .inner-tab {
		background: #ffffff;
	}

	.bargain-container .inner-tab .tab-list {
		height: 100rpx;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		background: #FFFFFF;
	}

	.bargain-container .inner-tab .item {
		height: 100rpx;
		line-height: 100rpx;
		white-space: nowrap;
		padding: 0 30rpx;
		font-size: 30rpx;
		color: #333333;
	}

	.bargain-container .inner-tab .item.active,
	.bargain-container .inner-tab .item .arrow.active .iconfont {
		background: #FFFFFF;
		font-size: 32rpx;
		color: #F6220C;
		position: relative;
	}

	.bargain-container .inner-tab .item.active::after {
		content: '';
		width: 60%;
		height: 4rpx;
		background: #F6220C;
		border-radius: 2rpx;
		position: absolute;
		bottom: 17rpx;
		left: 0;
		right: 0;
		margin: auto;
	}

	.bargain-container .inner-tab .box {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: row;
	}

	.bargain-container .inner-tab .arrows {
		margin-left: 10rpx;
		line-height: 0;
	}

	.bargain-container .inner-tab .iconfont {
		line-height: 24rpx;
		font-size: 24rpx;
	}

	.bargain-container .inner-tab .arrow,
	.bargain-container .inner-tab .svg-icon {
		width: 20rpx;
		height: 20rpx;
	}

	.bargain-container .banner-image {
		width: 100%;
		box-sizing: border-box;
	}

	.bargain-container .banner-image image {
		width: 750rpx;
		height: 365rpx;
	}

	.bargain-container .ad-datetime::v-deep text {
		color: #333333;
		font-size: 28rpx;
	}

	.bargain-container .ad-datetime::v-deep .box {
		padding: 4rpx;
		border-radius: 4rpx;
		background: #F6220C;
		color: #ffffff;
	}

	.bargain-list .list {
		padding: 20rpx;
	}

	.bargain-list .list .item {
		width: 100%;
		padding: 30rpx;
		margin-bottom: 20rpx;
		box-sizing: border-box;
		border-radius: 16rpx;
		background: #ffffff;
	}

	.bargain-list .product-cover {
		padding: 4rpx;
	}

	.bargain-list .product-cover image {
		width: 200rpx;
		height: 200rpx;
		border-radius: 12rpx;
	}

	.bargain-list .product-info {
		flex: 1;
		padding-left: 20rpx;
		overflow: hidden;
	}

	.bargain-list .product-cover .people-num {
		position: absolute;
		right: 0;
		bottom: 0;
		left: 0;
		height: 50rpx;
		padding: 0 20rpx;
		line-height: 50rpx;
		font-size: 24rpx;
		box-sizing: border-box;
		background: rgba(0, 0, 0, 0.6);
	}

	.bargain-list .ad-datetime .box {
		padding: 4rpx;
		border-radius: 4rpx;
		background: #000000;
		color: #ffffff;
	}

	.bargain-list .product-title {
		width: 100%;
		height: 40rpx;
		line-height: 40rpx;
		font-size: 32rpx;
		color: #333333;
	}

	.bargain-list .people-num {
		width: 100%;
	}

	.bargain-list .already-sale {
		padding: 4rpx 0;
		color: #999;
		font-size: 24rpx;
	}

	.bargain-list .price {
		width: 100%;
		color: $dominant-color;
		font-size: 24rpx;
	}

	.bargain-list .price .num {
		padding: 0 4rpx;
	}

	.bargain-list .slider-box .slider {
		margin-top: 10rpx;
		height: 10rpx;
		background: #cccccc;
		border-radius: 5rpx;
	}

	.bargain-list .slider-box .slider-inner {
		height: 10rpx;
		background: #e2231a;
		border-radius: 5rpx;
	}

	.bargain-list .right-btn button {
		height: 60rpx;
		line-height: 60rpx;
		border-radius: 30rpx;
		background: #8D60FF;
		color: #ffffff;
		font-size: 32rpx;
	}
</style>
